"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classcat = _interopRequireDefault(require("classcat"));

var _LabelText = _interopRequireDefault(require("./LabelText"));

var _InputError = _interopRequireDefault(require("./InputError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Input = /*#__PURE__*/(0, _react.forwardRef)(({
  className,
  label,
  inputRef,
  type,
  err,
  ...rest
}, ref) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_LabelText.default, null, label), /*#__PURE__*/_react.default.createElement("input", _extends({
  className: (0, _classcat.default)({
    err
  }),
  ref: inputRef || ref,
  type: type || 'text'
}, rest, {
  autoComplete: "off"
})), err && /*#__PURE__*/_react.default.createElement(_InputError.default, null, err))));
Input.propTypes = {
  label: _propTypes.default.string
};
Input.defaultProps = {
  label: ''
};

var _default = (0, _styledComponents.default)(Input).withConfig({
  displayName: "Input",
  componentId: "nc231p-0"
})(["margin-bottom:24px;input{outline:none;height:48px;margin-top:8px;padding:0 16px;width:100%;border:1px solid #a9a9a9;border-radius:2px;font-weight:300;color:#333;", ";&:focus:not(.err){border-color:", ";}&.err{border-color:", ";}}"], p => p.theme.transition, p => p.theme.colors.main, p => p.theme.colors.err);

exports.default = _default;